import * as BrandLogos from '@fox/icons/brand-logos';
import React, { ElementType, forwardRef } from 'react';

export type BrandLogoName = keyof typeof BrandLogos;

interface BrandLogoProps {
	logoName: BrandLogoName;
	title?: string;
	style?: React.CSSProperties;
	className?: string;
}

export const BrandLogo = forwardRef<SVGSVGElement, BrandLogoProps>(({ logoName, title, style, className }, ref) => {
	const LogoComponent = BrandLogos[logoName] as ElementType;

	return <LogoComponent ref={ref} aria-label={title} style={style} className={className} />;
});
